export const getValueFromLocalStorage = key => {
  try {
    return localStorage.getItem(key);
  } catch (_unused) {
    return null;
  }
};
export const setValueInLocalStorage = (key, value) => {
  try {
    localStorage.setItem(key, value);
  } catch (_unused2) {
    return;
  }
};